<template>
  <div v-if="product && product.care && product.care.length" class="care">
    <h2 class="light title">Care Instructions</h2>
    <Divider />
    <ul class="care-list">
      <li v-for="(care, index) of product.care" :key="index" class="care-list-item">
        {{ care }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Divider from './Divider.vue';

export default {
  name: 'Care',
  components: {
    Divider,
  },
  computed: {
    ...mapState('product', ['product']),
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.care {
  .divider {
    display: none;
  }

  .title {
    margin-bottom: 8px;
  }

  .care-list {
    list-style-type: disc;
    margin-left: 20px;

    .care-list-item {
      display: list-item;
    }
  }

  @media (max-width: $tablet-breakpoint - 1) {
    margin-top: 24px;

    .divider {
      display: block;
      margin-top: 10px;
      margin-bottom: 24px;
    }
  }
}
</style>
